import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "./queryKeys";


export const useGetAppointmentCalendarEvents = (appointmentId: string, enabled = true) => {
  return useQuery({
    queryKey: appointmentQKeys.calendarEvents(appointmentId),
    queryFn: async () => {
      const res = await api.get(`appointments/${appointmentId}/calendar-events`);
      return res.data;
    },
    enabled: enabled && !!appointmentId,
  });
};
